export function cloudpayments({ publicId, serviceTypeName, price, email, invoiceId, serviceId, receipt, additionData }, redirectSuccessUrl) {
    const widget = new window.cp.CloudPayments();
    const data = {
        'guid':  serviceId,
        'serviceid': serviceId,
        'elementid' : 'boookstart_request',
        'service': 'bookstart',
        'cloudPayments': {
            'CustomerReceipt': receipt, // онлайн-чек
        },
        'email': email,
        'comment' : 'Услуга для букстарта, для пользоватля' + email
    };
    const newData = Object.assign(data, additionData);
    //console.log(data);
    widget.charge({ // (для одностадийного платежа)
        //      widget.auth({ // (для двухстадийного)
        publicId: publicId || '', // id из личного кабинета
        description: `Оплата автором дополнительной услуги: ${serviceTypeName}`, // назначение
        amount: price, // сумма
        email,
        currency: 'RUB', // валюта
        invoiceId: invoiceId || '', // номер заказа  (необязательно)
        //      accountId: '321', //идентификатор плательщика (необязательно)
        requireEmail: true,
        skin: 'classic', // дизайн виджета
        data: newData,
    },
    (/* options */) => { // success
        // действие при успешной оплате
        if (typeof redirectSuccessUrl !== 'undefined' && redirectSuccessUrl.length) {
            setTimeout(() => {
                window.location.href = redirectSuccessUrl;
            }, 1500);
        } else {
            setTimeout(() => {
                window.location.reload();
            }, 1500);
        }
    },
    (/* reason, options */) => { // fail
        // действие при неуспешной оплате
    });
}